"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Loading_1 = __importDefault(require("./Loading"));
exports.default = Loading_1.default;
//# sourceMappingURL=index.js.map